import React from 'react'
import {
  BetmenList,
  BetmenListActions,
  BetmenListBody,
  BetmenListHeader,
  BetmenListHeaderCell,
  BetmenListItemCard,
  BetmenListItemCardCell,
} from '../../../../../common/components'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { useSelectedLanguage } from '../../../../../common/hooks/useSelectedLanguage'
import { ChipGroup } from '../../../../../common/components/ChipGroup/ChipGroup'
import { DoctorPatientTreatment } from '../../types/treatments.types'
import { formatDayjsToStringDateType } from '../../../../../utils/formatToDateType'
import { useUserProfile } from '../../../../../common/hooks/useUserProfile'
import { useHistory } from 'react-router-dom'
import { useUserType } from '../../../../../common/hooks'

interface TreatmentListProps {
  treatments: DoctorPatientTreatment[]
  loading: boolean
  patientId: string
  onEdit?: (value: DoctorPatientTreatment) => void
}
export const TreatmentList: React.FC<TreatmentListProps> = ({
  treatments,
  loading,
  patientId,
  onEdit,
}) => {
  const { t } = useTranslation()
  const selectedLanguage = useSelectedLanguage()
  const profile = useUserProfile()
  const history = useHistory()
  const userType = useUserType()

  return (
    <BetmenList
      dataSource={treatments}
      loading={loading}
      gridColumnSizes={[3, 2, 2, 2, 2, 1]}
      notFoundMessage={t('treatment:assistant.noActiveTreatment')}
      header={
        <BetmenListHeader>
          <BetmenListHeaderCell>
            {t('patients:treatment.name')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell>
            {t('patients:treatment.bno')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell>
            {t('patients:treatment.createdBy')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell>
            {t('patients:treatment.startDate')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell>
            {t('patients:treatment.endDate')}
          </BetmenListHeaderCell>
          <BetmenListHeaderCell></BetmenListHeaderCell>
        </BetmenListHeader>
      }
    >
      <BetmenListBody>
        {treatments.map((treatment) => (
          <BetmenListItemCard
            click={() => {
              history.push(`/${userType}/patients/${patientId}/${treatment.id}`)
            }}
            key={'wp+' + treatment.id}
          >
            <BetmenListItemCardCell>
              {treatment.title[selectedLanguage]}
            </BetmenListItemCardCell>
            <BetmenListItemCardCell>
              {
                <ChipGroup
                  values={treatment.bnoCodes.map((code) => code.code)}
                  limitTags={2}
                />
              }
            </BetmenListItemCardCell>
            <BetmenListItemCardCell typographyProps={{ fontWeight: 400 }}>
              {t('common:formattedNameFull', {
                title: treatment.doctor.title,
                firstName: treatment.doctor.firstName,
                lastName: treatment.doctor.lastName,
              })}
            </BetmenListItemCardCell>
            <BetmenListItemCardCell typographyProps={{ fontWeight: 400 }}>
              {formatDayjsToStringDateType(
                treatment.firstAndLastDates?.firstAppointmentDate
              )}
            </BetmenListItemCardCell>
            <BetmenListItemCardCell typographyProps={{ fontWeight: 400 }}>
              {formatDayjsToStringDateType(
                treatment.firstAndLastDates?.lastAppointmentDate
              )}
            </BetmenListItemCardCell>
            {profile?.id === treatment.doctor.id && onEdit && (
              <BetmenListActions
                display="flex"
                justifyContent="flex-end"
                edit={() => {
                  onEdit?.(treatment)
                }}
              />
            )}
          </BetmenListItemCard>
        ))}
      </BetmenListBody>
    </BetmenList>
  )
}
